/**
 * @module selectors/closest
 */

/**
 * Returns the closest element of a node, if any, matching the provided selector
 * @param {String} selector
 * @param {Node} target
 * @returns {?Element}
 */
export default (selector, target) => {
  const { closest, parentElement } = target
  const node = closest ? target : parentElement
  
  return node.closest(selector)
}
